/**
 * The "Execution" menu. See lib/navigation/nav-manifest.js for the entry shape
 * and the vocabulary `requires` draws from.
 */

/** @type {import("@/lib/navigation/nav-manifest").NavManifestItem[]} */
export const EXECUTION_ITEMS = [
  // In the order a deal uses them: write the outreach, run the call, review
  // it, diagnose the deal. On-the-fly Plays is a role play, so it is under
  // Practice only.
  {
    href: "/workspaces/scripts",
    label: "Script Generator",
    description: "Craft personalized outreach that connects.",
    iconName: "IoDocumentTextOutline",
    requires: "scriptGenerator",
  },
  {
    // The live call coach: in a browser, the page that offers the desktop and
    // phone apps; inside the desktop app, Guide itself. Open to every member.
    href: "/guide",
    label: "Guide (Live Call Coach)",
    heading: "Your next line, as the call happens",
    description:
      "Guide listens to a real conversation and hands you the next line, the right move, and what to watch for. On a computer it floats over Zoom, Meet or Teams.",
    iconName: "IoNavigateCircleOutline",
    requires: "workspace",
  },
  {
    // Opens on the rep's analyzed calls, uploaded or recorded, with "Analyze
    // a conversation" on the list, as Deal Clinic opens on its readouts with
    // "Diagnose Deal". The analyzer itself is a step, not a destination
    // (Michael, 20 October).
    href: "/dashboard/transcript-results",
    label: "Conversation Analysis",
    heading: "Conversations",
    shortcut: "A",
    iconName: "IoStatsChartOutline",
    requires: "conversationAnalysis",
  },
  {
    href: "/dem-cog/reports",
    label: "Deal Clinic",
    heading: "Deal Diagnostic Readouts",
    description:
      "Review your discovery conversations for deal health, key gaps, and what to focus on next.",
    iconName: "IoBarChartOutline",
    requires: "dealClinic",
  },
  {
    // Prep5 is an external service. Practice-only studios should not see the
    // Execution menu at all (SAL-2532), so only offer Prep5 once the studio has
    // at least one execution module enabled. Training-mode restrictions also
    // apply, with the usual exemptions for admins, supervisors, and superusers.
    href: "https://prep5.salesably.ai/dashboard",
    label: "Prep5 (AI Sales Prep)",
    iconName: "IoFlashOutline",
    external: true,
    requires: ["anyExecutionModule", "notTrainingModeRestricted"],
  },
];
